import { create } from "zustand";
import {
    getActiveWorldGenerationJobs,
    dismissWorldGenerationJob,
} from "@/lib/actions/wiki-editor-generation-actions";
import type { WikiGenerationJobView } from "@/lib/actions/wiki/wiki-generation-types";

// Drives the global world-generation progress tray. The DB is the source of
// truth (jobs survive navigation/reload); this store just mirrors the active
// rows for the current author and is re-fetched on a poll while any job runs.
interface WikiGenerationState {
    jobs: WikiGenerationJobView[];
    /** Pull the current author's active/recent jobs from the server. */
    refresh: () => Promise<void>;
    /** Optimistically hide a finished job and persist the dismissal. */
    dismiss: (jobId: string) => Promise<void>;
}

export const useWikiGenerationStore = create<WikiGenerationState>((set) => ({
    jobs: [],
    refresh: async () => {
        try {
            const jobs = await getActiveWorldGenerationJobs();
            set({ jobs });
        } catch {
            // Not authenticated or a transient failure — keep the last snapshot.
        }
    },
    dismiss: async (jobId) => {
        set((state) => ({ jobs: state.jobs.filter((j) => j.id !== jobId) }));
        try {
            await dismissWorldGenerationJob(jobId);
        } catch {
            // Optimistic — the next refresh reconciles if the server disagrees.
        }
    },
}));
